"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EditorialPageFeature = void 0;
const EditorialPageFeature = exports.EditorialPageFeature = {
    /** Enable personal subscriptions, docs: https://dev.azure.com/oriflame/GlobalDev/_wiki/wikis/GlobalDev.wiki/11422/Personal-subscriptions */ PersonalSubscriptions: '7D673EF4-D085-44B5-BB1C-8FE57F1286BD'
};
